







































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

const CONTAINER_HEIGHT_PX = 146
const ITEM_HEIGHT_PX = 36
const VIRTUAL_BUFFER_ITEMS = 23

type GroupTagVirtualItem = {
  id: string | number
  choose?: boolean
  name?: string
  _displayName?: string
  [key: string]: unknown
}

@Component
export default class GroupTagVirtualList extends Vue {
  @Prop({ default: () => [] }) private items!: GroupTagVirtualItem[]
  @Prop({ default: 'name' }) private displayNameKey!: string
  @Prop({ default: '' }) private className!: string
  @Prop({ type: Boolean, default: false }) loading!: boolean
  @Prop({ type: Boolean, default: false }) private clickable!: boolean
  @Prop({ type: Boolean, default: false }) private showChooseClass!: boolean

  private scrollTop = 0

  get containerClass(): string[] {
    return ['group-tag-card-list', 'card', this.className].filter(Boolean)
  }

  get visibleItems(): GroupTagVirtualItem[] {
    return this.items.slice(this.startIndex, this.endIndex)
  }

  get startIndex(): number {
    return Math.max(
      0,
      Math.floor(this.scrollTop / ITEM_HEIGHT_PX) - VIRTUAL_BUFFER_ITEMS
    )
  }

  get endIndex(): number {
    const visibleCount =
      Math.ceil(CONTAINER_HEIGHT_PX / ITEM_HEIGHT_PX) + VIRTUAL_BUFFER_ITEMS * 2
    return Math.min(this.items.length, this.startIndex + visibleCount)
  }

  get topSpacerHeight(): number {
    return this.startIndex * ITEM_HEIGHT_PX
  }

  get bottomSpacerHeight(): number {
    return Math.max(0, (this.items.length - this.endIndex) * ITEM_HEIGHT_PX)
  }

  get topSpacerStyle(): Record<string, string> {
    return this.getSpacerStyle(this.topSpacerHeight)
  }

  get bottomSpacerStyle(): Record<string, string> {
    return this.getSpacerStyle(this.bottomSpacerHeight)
  }

  @Watch('items')
  onItemsChange() {
    this.resetScroll()
  }

  getDisplayName(item: GroupTagVirtualItem): string {
    const value = item._displayName ?? item[this.displayNameKey] ?? item.name
    return String(value ?? '')
  }

  getListItemClass(item: GroupTagVirtualItem): Record<string, boolean> {
    return {
      'cursor-pointer': this.clickable,
      'bg-secondary-less': this.showChooseClass && !!item.choose
    }
  }

  getSpacerStyle(height: number): Record<string, string> {
    return { height: `${height}px` }
  }

  handleItemClick(item: GroupTagVirtualItem) {
    if (!this.clickable) return
    this.$emit('item-click', item)
  }

  onScroll(event: Event) {
    const target = event.target as HTMLElement | null
    this.scrollTop = target?.scrollTop ?? 0
  }

  resetScroll() {
    this.scrollTop = 0
    this.$nextTick(() => {
      const container = this.$refs.container as HTMLElement | undefined
      if (container) container.scrollTop = 0
    })
  }
}
